<pui-sub-header>
    <div class="d-flex w-100 justify-content-between align-items-center">
        <div>
            <button pui-button variant="secondary" (click)="onGoBack()"><pui-icon left
                    icon="arrow-left" />Powrót</button>
        </div>
        <div>
            @if(editMode){Edytuj grupę
            } @else { Dodaj grupę
            }
        </div>
        <div class="d-flex gap-12">
            <button pui-button variant="primary" (click)="onSubmit()">
                @if(editMode){
                Zapisz
                } @else {
                Dodaj grupę
                }
            </button>
        </div>
    </div>
</pui-sub-header>


<form class="page-container" [formGroup]="groupForm">
    <pui-form-group [title]="'Ogólne'" [description]="'Podaj informacje ogólne dla grupy'">
        <pui-form-row>
            <pui-form-field>
                <pui-label>Nazwa grupy</pui-label>
                <input puiInput type="text" placeholder="Nazwa grupy" formControlName="name" />
                <rqa-field-error ngProjectAs="pui-form-field-error" [control]="groupForm.get('name')">
                </rqa-field-error>
            </pui-form-field>
        </pui-form-row>

        <pui-form-row>
            <pui-form-field>
                <pui-label>Typ</pui-label>
                <pui-select [multiple]="false" formControlName="group">
                    <pui-placeholder>Wybierz</pui-placeholder>
                    @for(option of groupTypeOptions; track $index){
                    <pui-option [value]="option">{{option}}</pui-option>
                    }
                </pui-select>
                <rqa-field-error ngProjectAs="pui-form-field-error" [control]="groupForm.get('group')">
                </rqa-field-error>
            </pui-form-field>
        </pui-form-row>

        <pui-form-row>
            <pui-form-field>
                <pui-label>Jednostka</pui-label>
                <input puiInput type="text" placeholder="Wybierz" formControlName="responsibleUnit" />
            </pui-form-field>
        </pui-form-row>
    </pui-form-group>

    <pui-form-group [title]="'Dodaj użytkowników'"
        [description]="'Wybierz użytkowników, którzy zostaną dodani do grupy'">
        <pui-table2 [dataSource]="filteredUsers()" [trackBy]="trackBy">
            <ng-container header>
                <form class="d-flex align-items-center w-100" [formGroup]="filtersForm">
                    <pui-form-field>
                        <pui-label>Wyszukaj</pui-label>
                        <pui-icon icon="search-md" left />
                        <input puiInput placeholder="Wyszukaj" formControlName="search" />
                    </pui-form-field>
                </form>
            </ng-container>
            <ng-template #header>
                <th>
                    <pui-checkbox [triState]="true" [value]="allSelected() ? true : (someSelected() ? null : false)"
                        (changed)="toggleAll()" />
                </th>

                <th>Użytkownik</th>
                <th>Imię</th>
                <th>Nazwisko</th>
                <th>Organizacja</th>
                <th>Rola</th>
            </ng-template>
            <ng-template #row let-row>
                <tr>
                    <td>
                        <pui-checkbox [value]="isSelected(row)" (changed)="toggleUser(row)" />
                    </td>
                    <td>{{ row.username }}</td>
                    <td>{{ row.firstName }}</td>
                    <td>{{ row.lastName}}</td>
                    <td>{{ row.organization }}</td>
                    <td>{{ row.role }}</td>
                </tr>
            </ng-template>
        </pui-table2>
    </pui-form-group>

</form>